/* FiveRiyal inner pages: product gallery + variants, cart page, quantity steppers, filters */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---- quantity steppers (product + cart) ---- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.fr-qty button');
    if (!b) return;
    const input = $('input', b.closest('.fr-qty'));
    const min = parseInt(input.min || '1', 10);
    let v = parseInt(input.value || '1', 10) + (b.dataset.dir === 'down' ? -1 : 1);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- product page ---- */
  $$('.fr-product').forEach((root) => {
    // gallery
    const main = $('.fr-gallery__main img', root);
    $$('.fr-gallery__thumb', root).forEach((t) => {
      t.addEventListener('click', () => {
        $$('.fr-gallery__thumb', root).forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
        if (main) { main.src = t.dataset.src; main.srcset = ''; }
      });
    });
    // variants
    const dataEl = $('[data-fr-variants]', root);
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const form = $('form.fr-ajax-add', root);
    const idInput = form && $('input[name="id"]', form);
    const priceMain = $('.fr-product__price-main', root);
    const priceOld = $('.fr-product__price-old', root);
    const save = $('.fr-product__save', root);
    const stock = $('.fr-stock', root);
    const btn = form && $('.fr-add-btn', form);
    const money = (cents) => {
      const fmt = dataEl.dataset.money || '{{amount}}';
      const v = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
    };
    const update = () => {
      const sel = $$('.fr-option', root).map((o) => { const c = $('input:checked', o); return c ? c.value : null; });
      const v = variants.find((x) => sel.every((s, i) => s === null || x.options[i] === s));
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceMain) priceMain.textContent = money(v.price);
      if (priceOld) { priceOld.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; priceOld.hidden = !(v.compare_at_price > v.price); }
      if (save) { const pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; save.textContent = pct ? ((dataEl.dataset.saveWord || 'Save') + ' ' + money(v.compare_at_price - v.price) + ' (' + pct + '%)') : ''; save.hidden = !pct; }
      if (stock) { stock.textContent = v.available ? (dataEl.dataset.inStock || 'In stock') : (dataEl.dataset.outStock || 'Out of stock'); stock.classList.toggle('fr-stock--out', !v.available); }
      if (btn) { btn.disabled = !v.available; $('.fr-add-label', btn).textContent = v.available ? (dataEl.dataset.addText || 'Add to Cart') : (dataEl.dataset.outStock || 'Sold out'); }
      if (v.featured_image && main) { main.src = v.featured_image.src; main.srcset = ''; }
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    };
    $$('.fr-option input', root).forEach((i) => i.addEventListener('change', update));
  });

  /* ---- generic AJAX add (product page + cards); buy-now redirects to checkout ---- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.fr-ajax-add');
    if (!form) return;
    e.preventDefault();
    const btn = $('.fr-add-btn', form);
    const buyNow = form.dataset.buyNow === '1';
    form.dataset.buyNow = '0';
    if (btn) btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) throw new Error(j.description || j.message || 'error');
        if (buyNow) { location.href = '/checkout'; return; }
        fetch('/cart.js').then((r) => r.json()).then((c) => $$('.fr-cart-count').forEach((el) => { el.textContent = c.item_count || ''; el.dataset.count = c.item_count; }));
        const msg = $('.fr-product__form-msg', form.parentElement);
        if (window.frToast) window.frToast((form.dataset.addedText || 'Added to cart') + ' <a href="/cart">' + (form.dataset.viewCartText || 'View cart') + ' →</a>');
        if (msg) msg.textContent = '';
      })
      .catch((err) => { const msg = $('.fr-product__form-msg', form.parentElement); if (msg) msg.textContent = err.message; else if (window.frToast) window.frToast(err.message); })
      .finally(() => btn && btn.classList.remove('is-loading'));
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.fr-buy-now');
    if (!b) return;
    e.preventDefault();
    const form = b.closest('form.fr-ajax-add');
    if (form) { form.dataset.buyNow = '1'; form.requestSubmit(); }
  });

  /* ---- cart page ---- */
  const cartRoot = () => $('[data-fr-cart]');
  function renderCart(html) {
    const root = cartRoot();
    if (!root) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-fr-cart]', doc);
    if (fresh) root.replaceWith(fresh);
    fetch('/cart.js').then((r) => r.json()).then((c) => $$('.fr-cart-count').forEach((el) => { el.textContent = c.item_count || ''; el.dataset.count = c.item_count; }));
  }
  function cartChange(body) {
    const root = cartRoot();
    if (!root) return;
    root.classList.add('is-busy');
    const sectionId = root.dataset.section;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => r.json())
      .then(() => fetch('/cart?section_id=' + sectionId).then((r) => r.text()))
      .then(renderCart)
      .catch(() => location.reload());
  }
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-fr-cart] .fr-qty input');
    if (!input) return;
    cartChange({ line: parseInt(input.dataset.line, 10), quantity: parseInt(input.value, 10) });
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-fr-cart] .fr-line__remove');
    if (rm) { e.preventDefault(); cartChange({ line: parseInt(rm.dataset.line, 10), quantity: 0 }); return; }
    const clear = e.target.closest('[data-fr-cart] .fr-cart__clear');
    if (clear) {
      e.preventDefault();
      if (!confirm(clear.dataset.confirm || 'Remove all items from your cart?')) return;
      const root = cartRoot(); root.classList.add('is-busy');
      fetch('/cart/clear.js', { method: 'POST' }).then(() => fetch('/cart?section_id=' + root.dataset.section).then((r) => r.text())).then(renderCart).catch(() => location.reload());
    }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form.fr-promo-form');
    if (!f) return;
    e.preventDefault();
    const code = ($('input', f).value || '').trim();
    if (!code) return;
    location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });

  /* ---- collection filters: auto-submit on change, sort select ---- */
  document.addEventListener('change', (e) => {
    const sort = e.target.closest('select[data-fr-sort]');
    if (sort) { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); return; }
    const cb = e.target.closest('form.fr-filter-form input[type="checkbox"]');
    if (cb) cb.form.requestSubmit();
  });
})();


/* ---- collection sidebar: dual price range, show more; product: tabs, gallery arrows ---- */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  $$('[data-fr-range]').forEach((r) => {
    const mn = $('.fr-range__in--min', r), mx = $('.fr-range__in--max', r), fill = $('.fr-range__fill', r);
    const hidden = $$('input[type="hidden"]', r);
    const hmin = hidden[0], hmax = hidden[1];
    const lmin = $('[data-min]', r), lmax = $('[data-max]', r), cur = r.dataset.currency || '';
    const max = parseFloat(r.dataset.max) || 100;
    const vals = () => { let a = parseFloat(mn.value), b = parseFloat(mx.value); if (a > b) { const t = a; a = b; b = t; } return [a, b]; };
    const paint = () => {
      const [a, b] = vals();
      fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%';
      lmin.textContent = cur + ' ' + a; lmax.textContent = cur + ' ' + b;
    };
    const commit = () => {
      const [a, b] = vals();
      hmin.value = a > 0 ? a : ''; hmax.value = b < max ? b : '';
      r.closest('form').requestSubmit();
    };
    [mn, mx].forEach((i) => { i.addEventListener('input', paint); i.addEventListener('change', commit); });
    paint();
  });
  $$('[data-fr-showmore]').forEach((b) => b.addEventListener('click', () => {
    const g = b.closest('[data-fr-group]'); const open = b.dataset.open === '1';
    $$('.is-extra', g).forEach((l) => { l.hidden = open; });
    b.dataset.open = open ? '0' : '1'; b.textContent = open ? b.dataset.more : b.dataset.less;
  }));
  $$('[data-fr-tabs]').forEach((t) => $$('.fr-tabs__nav button', t).forEach((b) => b.addEventListener('click', () => {
    $$('.fr-tabs__nav button', t).forEach((x) => x.classList.toggle('is-active', x === b));
    $$('.fr-tabs__panel', t).forEach((p) => p.classList.toggle('is-active', p.dataset.panel === b.dataset.tab));
  })));
  $$('.fr-gallery').forEach((g) => {
    const thumbs = $$('.fr-gallery__thumb', g); if (thumbs.length < 2) return;
    const step = (d) => { const i = thumbs.findIndex((t) => t.classList.contains('is-active')); thumbs[(i + d + thumbs.length) % thumbs.length].click(); };
    const p = $('[data-fr-gallery-prev]', g), n = $('[data-fr-gallery-next]', g);
    if (p) p.addEventListener('click', () => step(-1));
    if (n) n.addEventListener('click', () => step(1));
  });
})();
